import { initState } from './InitApplicationState';

const isDarkTheme = (value: string) => {
  var className = "hide-element";
  if(value === 'light'){
    className =  "show-element";
  }
  return className;
}

const isLightTheme = (value: string) => {
  var className = "hide-element";
  if(value === 'dark'){
    className =  "show-element";
  }

  return className;
}

export function reportReducer(state = initState, action:{type:string, value:any}) {
    switch(action.type) {
      case "SEARCH_TERMS_UPDATED":
          return { ...state,
            searchTerms: action.value,
        };
      case "THEME":
          return { ...state,
            theme: action.value,
            isDark: isDarkTheme(action.value),
            isLight: isLightTheme(action.value)
        };
      case "USER_SEARCH_RESULTS":
          return { ...state,
            userSearchResults: action.value
        };
      case "SELECTED_USER_DETAILS":
        return { ...state, 
          selectedUserDetails: action.value
        };
      default:
        return state;
    }



  };
